export default __webpack_public_path__ + "static/BasierCircle-Regular-d5326dfaf1dbebef0f4c2ebbab4e7bbf.woff2";